<template>
  <b-modal
    :active="value"
    :width="width"
    :full-screen="fullScreen"
    :can-cancel="canCancel"
    custom-class="is-sheet"
    animation="sheetLeft"
    @update:active="$emit('input', $event)"
  >
    <div class="modal-sheet-content">
      <slot />
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    value: {
      default: false,
      type: Boolean
    },
    width: {
      default: 960,
      type: Number
    },
    fullScreen: {
      default: false,
      type: Boolean
    },
    canCancel: {
      default: true,
      type: Boolean
    }
  },
};
</script>
